<template>

  <div class="mt-4">
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-light" role="status"></div>
      <p>Cargando...</p>
    </div>
    <!-- Page Header -->
    <div class="page-header">
      <h1 class="page-header-title"><i class="bi bi-file-earmark-text me-2"></i>Listado de Envíos Provincia — Documentos</h1>
    </div>

    <!-- Filtros -->
    <div class="filter-card">
      <div class="row g-2">
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">RUC</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.ruc" placeholder="Ingrese RUC" />
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Razón Social</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.razon_social" placeholder="Razón social..." />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Cliente Final</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.cliente_final" placeholder="Cliente final..." />
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Área Solicitante</label>
          <select class="form-select form-select-sm" v-model="filtros.cod_metodo_envio_id">
            <option value="">Todos</option>
            <option v-for="item in codigosMetodoEnvio" :key="item.id" :value="item.id">{{ item.codigo }}</option>
          </select>
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">N° Orden de Compra</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.pedido" placeholder="N° Orden de Compra" />
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">N° Factura</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.numero_factura" placeholder="N° Factura" />
        </div>
        <div class="col-md-2 d-none d-md-block">
          <label class="form-label">OTM</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.otm" placeholder="N° OTM" />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Rango de Fechas</label>
          <div class="row gx-1">
            <div class="col-6"><input type="date" class="form-control form-control-sm" v-model="filtros.fecha_inicio" /></div>
            <div class="col-6"><input type="date" class="form-control form-control-sm" v-model="filtros.fecha_fin" /></div>
          </div>
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Estado</label>
          <select class="form-select form-select-sm" v-model="filtros.id_estados_envio">
            <option value="">Todos</option>
            <option v-for="item in estadosEnvio" :value="item.id" :key="item.id">{{ item.nombre }}</option>
          </select>
        </div>
        <div class="col-md-2 d-none d-md-block" v-if="esSuperAdmin()">
          <label class="form-label">Modalidad</label>
          <select class="form-select form-select-sm" v-model="filtros.id_modalidades_envio">
            <option value="">Todos</option>
            <option value="2">CONSOLIDADO</option>
            <option value="3">EXCLUSIVO</option>
            <option value="4">AEREO</option>
          </select>
        </div>
        <!-- Los botones se ubican en la última fila de filtros si hay espacio (una fila menos) -->
        <div class="col-12 col-md-auto ms-auto d-flex justify-content-end align-items-end">
          <div class="filter-actions">
            <button class="btn-filter" @click="aplicarFiltros"><i class="bi bi-search"></i> Buscar</button>
            <button class="btn-clear" @click="limpiarFiltros()"><i class="bi bi-x-circle"></i> Limpiar</button>
            <button class="btn-export" @click="exportarExcel"><i class="bi bi-file-earmark-excel"></i> Exportar</button>
            <button class="btn-pdf" @click="exportarReportePdf" title="Programación de la ruta: hasta 3 días"><i class="bi bi-file-earmark-pdf"></i> Ruta</button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive mt-4 d-none d-md-block">
      <table class="table table-sm table-bordered table-hover align-middle table-doc-list">
        <thead>
          <tr>
            <th>Rastreo</th>
            <th>F. Salida</th>
            <th>F. Entrega</th>
            <th>Área Solicitante</th>
            <th>Factura</th>
            <th>OTM</th>
            <th>Orden Compra</th>
            <th>Remitente</th>
            <th>Destinatario</th>
            <th>Estado</th>
            <th class="col-acciones">Acciones</th>
          </tr>
        </thead>
        <tbody style="font-size:0.8rem;">
          <tr v-for="(envio, index) in envios" :key="index">
            <td class="text-nowrap">
              <a :href="`/tracking?numeroRastreo=${envio.rastreo}`" class="fw-semibold text-primary">{{ envio.rastreo }}</a>
            </td>
            <td class="celda-id">{{ formatFecha(envio.fecha_salida) }}</td>
            <td class="celda-id">{{ formatFecha(envio.fecha_entrada_maxima) }}</td>
            <td>{{ envio.area_solicitante }}</td>
            <td>{{ envio.documentos && envio.documentos.length > 1 ? 'VARIAS FACTURAS' : envio.facturas_concatenadas }}</td>
            <td>{{ envio.documentos && envio.documentos.length > 1 ? 'VARIOS OTMS' : envio.otm_concatenadas }}</td>
            <td>{{ envio.documentos && envio.documentos.length > 1 ? 'VARIAS OC' : envio.oc_concatenadas }}</td>
            <td class="celda-entidad">
              <div class="celda-dato">{{ envio.ruc_remitente }}</div>
              <div class="entidad-nombre" :title="envio.empresa_sucursal">{{ envio.empresa_sucursal }}</div>
              <div class="celda-dato">{{ envio.ubicacion_remitente }}</div>
            </td>
            <td class="celda-entidad">
              <div class="celda-dato">{{ envio.ruc_destinatario }}</div>
              <div class="entidad-nombre" :title="envio.empresa_sucursal_destino">{{ envio.empresa_sucursal_destino }}</div>
              <div class="celda-dato">{{ envio.ubicacion_destinatario }}</div>
            </td>
            <td class="text-center p-1">
              <span :class="getBadgeClass(envio.id_estados_envio)" @click="openEstadoEnvio(envio)" style="cursor:pointer; white-space:normal; word-break:break-word;">
                {{ envio.estado_envio }}
              </span>
            </td>
            <td class="col-acciones">
              <div class="btn-group">
                <button class="btn-acciones dropdown-toggle" type="button" title="Acciones" aria-label="Acciones" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end custom-dropdown" data-bs-popper="static">
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="mostrarDetalle(envio)">
                      <i class="bi bi-search text-dark"></i> Mostrar detalles
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="editarEnvio(envio)">
                      <i class="bi bi-pencil text-dark"></i> Editar envío
                    </a>
                  </li>
                  <li v-if="esSuperAdmin()">
                    <a class="dropdown-item" href="#" @click.prevent="abrirGestionarModal(envio)">
                      <i class="bi bi-list-task text-dark"></i> Gestionar
                    </a>
                  </li>
                  <li v-if="esSuperAdmin()">
                    <a class="dropdown-item" href="#" @click.prevent="abrirCargarArchivosModal(envio)">
                      <i class="bi bi-upload text-dark"></i> Documentos
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="abrirGestionGuiasModal(envio)">
                      <i class="bi bi-file-text text-dark"></i> Gestión de Guías
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="eliminarEnvio(envio)">
                      <i class="bi bi-trash text-danger"></i> Eliminar
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-block d-md-none mt-3">
      <div v-for="(envio, index) in envios" :key="index" class="card shadow-sm mb-3 border-0">
        <div class="card-body p-3">
          <div @click.prevent="mostrarDetalle(envio)">
            <h6 class="card-title fw-bold text-primary mb-2">
              Rastreo: <a :href="`/tracking?numeroRastreo=${envio.rastreo}`">{{ envio.rastreo }}</a>
            </h6>
            <p class="mb-1"><strong>Destino:</strong> {{ envio.ubicacion_destinatario }}</p>
            <p class="mb-1"><strong>Fecha Salida:</strong> {{ formatFecha(envio.fecha_salida) }}</p>
            <p class="mb-1"><strong>Fecha Entrega:</strong> {{ formatFecha(envio.fecha_entrada_maxima) }}</p>
            <p class="mb-1"><strong>Area solicitante:</strong> {{ envio.area_solicitante }}</p>
            <p class="mb-1"><strong>Solicitante:</strong> {{ envio.solicitante }}</p>
            <p class="mb-1"><strong>Remitente:</strong> {{ envio.empresa_sucursal }} ({{ envio.ubicacion_remitente }})</p>
            <p class="mb-1"><strong>Destinatario:</strong> {{ envio.empresa_sucursal_destino }} ({{ envio.ubicacion_destinatario }})</p>
          </div>
          <p class="mb-1"><strong>Estado:</strong>
            <span :class="getBadgeClass(envio.id_estados_envio)" class="mx-2" @click="openEstadoEnvio(envio)">
              {{ envio.estado_envio }}
            </span>
          </p>
          <div class="btn-group w-100 mt-2">
            <button class="btn btn-outline-dark btn-sm dropdown-toggle w-100" type="button" data-bs-toggle="dropdown">
              <i class="bi bi-three-dots-vertical"></i> Opciones
            </button>
            <ul class="dropdown-menu w-100">
              <li>
                <a class="dropdown-item" href="#" @click.prevent="mostrarDetalle(envio)">
                  <i class="bi bi-search text-dark"></i> Mostrar detalles
                </a>
              </li>
              <li v-if="esSuperAdmin()">
              <a class="dropdown-item" href="#" @click.prevent="abrirGestionarModal(envio)">
                <i class="bi bi-file-text text-dark"></i> Gestionar
              </a>
            </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="abrirGestionGuiasModal(envio)">
                  <i class="bi bi-file-text text-dark"></i> Gestión de Guías
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginación (25 por página, viene paginado desde el backend) -->
    <PaginacionListado :pagina="pagina" :total-paginas="totalPaginas" :total="totalEnvios" :por-pagina="porPagina"
      :en-pagina="envios.length" :cargando="isLoading" etiqueta="envíos" @cambiar="cambiarPagina" />



    <div v-if="modalGestionANW" id="modalGestionANW" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content shadow-lg border-0">
          <!-- Encabezado -->
          <div class="modal-header">
            <h5 class="modal-title">Gestión del Envío</h5>
            <button type="button" class="btn-close" @click="modalGestionANW = false"></button>
          </div>
          <div class="modal-body p-4">
            <div class="mb-4">
              <ShippingANW ref="shippingANWRef" :envio="detalleEnvio"></ShippingANW>
            </div>
            <div class="mt-3 d-flex justify-content-end mb-3"><button @click="guardarGestion()" type="submit"
                class="btn btn-primary d-flex align-items-center gap-2"><i class="bi bi-floppy"></i> Guardar </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modalDetalle" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-lg modal-fullscreen-sm-down">
        <div class="modal-content shadow-lg border-0">

          <!-- Encabezado -->
          <div class="modal-header">
            <h5 class="modal-title">Detalles del Envío</h5>
            <button type="button" class="btn-close" @click="cerrarDetalle"></button>
          </div>

          <!-- Cuerpo -->
          <div class="modal-body p-4">
            <div class="d-none d-md-block">

              <!-- Datos Generales -->
              <div class="mb-4">
                <h6 class="fw-bold text-primary">Datos Generales</h6>
                <table class="table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <td><strong>N° de Rastreo:</strong><br><a :href="`/tracking?numeroRastreo=${detalleEnvio.rastreo}`">{{ detalleEnvio.rastreo }}</a></td>
                      <td><strong>Area Solicitante:</strong><br>{{ detalleEnvio.area_solicitante }}</td>
                      <td><strong>Solicitante:</strong><br>{{ detalleEnvio.solicitante }}</td>
                      <td><strong>OTM:</strong><br>{{ detalleEnvio.otm_concatenadas }}</td>
                    </tr>
                    <tr>
                      <td><strong>Número Factura:</strong><br>{{ detalleEnvio.facturas_concatenadas }}</td>
                      <td><strong>Orden de Compra:</strong><br>{{ detalleEnvio.oc_concatenadas }}</td>
                      <td colspan="2"><strong>Documentos Extras:</strong><br>{{ detalleEnvio.documentos_extras_concatenadas }}</td>
                    </tr>
                    <tr>
                      <td colspan="4"><strong>Observaciones:</strong><br>{{ detalleEnvio.observaciones }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Información de Envío -->
              <div class="mb-4">
                <h6 class="fw-bold text-primary">Información de Envío</h6>
                <table class="table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <td><strong>RUC Remitente:</strong><br>{{ detalleEnvio.ruc_remitente }}</td>
                      <td><strong>Remitente (Cliente Inicial - Final):</strong><br>{{ detalleEnvio.empresa_sucursal }}</td>
                      <td><strong>Dirección:</strong><br>{{ direccionRemitente }}</td>
                    </tr>
                    <tr>
                      <td><strong>RUC Destinatario:</strong><br>{{ detalleEnvio.ruc_destinatario }}</td>
                      <td><strong>Destinatario (Cliente Inicial - Final):</strong><br>{{ detalleEnvio.empresa_sucursal_destino }}</td>
                      <td><strong>Dirección:</strong><br>{{ direccionDestinatario }}</td>
                    </tr>
                    <tr>
                      <td><strong>Tipo de Unidad:</strong><br>{{ detalleEnvio.tipo_unidad_detalle }}</td>
                      <td><strong>Fecha de Salida:</strong><br>{{ formatFecha(detalleEnvio.fecha_salida) }}</td>
                      <td><strong>Fecha de Entrega:</strong><br>{{ formatFecha(detalleEnvio.fecha_entrada_maxima) }}</td>
                    </tr>
                    <tr>
                      <td><strong>Horario de Salida:</strong><br>{{ formatHora(detalleEnvio.horario_salida) }}</td>
                      <td><strong>Horario de Entrega:</strong><br>{{ formatHora(detalleEnvio.horario_entrega) }}</td>
                      <td><strong>Guía de Transportista:</strong><br>{{ detalleEnvio.guias_transportistas_concatenadas || '-' }}</td>
                    </tr>
                    <tr>
                      <td><strong>Estado del Envío:</strong><br>{{ detalleEnvio.estado_envio }}</td>
                      <td><strong>Tipo de Envío:</strong><br>{{ detalleEnvio.modalidades_envio }} - {{ detalleEnvio.tipo_envio }}</td>
                      <td><strong>Lead Time Esperado:</strong><br>{{ detalleEnvio.lead_time_esperado }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>

            <!-- Móvil -->
            <div class="d-block d-md-none">
              <h6 class="mt-4 fw-bold text-primary">Datos Generales</h6>
              <div class="card mb-2">
                <div class="card-body">
                  <p><strong>N° de Rastreo:</strong> <a :href="`/tracking?numeroRastreo=${detalleEnvio.rastreo}`">{{ detalleEnvio.rastreo }}</a></p>
                  <p><strong>Area Solicitante:</strong> {{ detalleEnvio.area_solicitante }}</p>
                  <p><strong>Solicitante:</strong> {{ detalleEnvio.solicitante }}</p>
                  <p><strong>Número Factura:</strong> {{ detalleEnvio.facturas_concatenadas }}</p>
                  <p><strong>Orden de Compra:</strong> {{ detalleEnvio.oc_concatenadas }}</p>
                  <p><strong>OTM:</strong> {{ detalleEnvio.otm_concatenadas }}</p>
                  <p><strong>Documentos Extras:</strong> {{ detalleEnvio.documentos_extras_concatenadas }}</p>
                  <p><strong>Observaciones:</strong> {{ detalleEnvio.observaciones }}</p>
                </div>
              </div>

              <h6 class="mt-4 fw-bold text-primary">Información de Envío</h6>
              <div class="card mb-2">
                <div class="card-body">
                  <p><strong>RUC Remitente:</strong> {{ detalleEnvio.ruc_remitente }}</p>
                  <p><strong>Remitente (Cliente Inicial - Final):</strong> {{ detalleEnvio.empresa_sucursal }}</p>
                  <p><strong>Dirección Remitente:</strong> {{ direccionRemitente }}</p>
                  <p><strong>RUC Destinatario:</strong> {{ detalleEnvio.ruc_destinatario }}</p>
                  <p><strong>Destinatario (Cliente Inicial - Final):</strong> {{ detalleEnvio.empresa_sucursal_destino }}</p>
                  <p><strong>Dirección Destinatario:</strong> {{ direccionDestinatario }}</p>
                  <p><strong>Estado del Envío:</strong> {{ detalleEnvio.estado_envio }}</p>
                  <p><strong>Tipo de Envío:</strong> {{ detalleEnvio.modalidades_envio }} - {{ detalleEnvio.tipo_envio }}</p>
                  <p><strong>Tipo de Unidad:</strong> {{ detalleEnvio.tipo_unidad_detalle }}</p>
                  <p><strong>Fecha de Salida:</strong> {{ formatFecha(detalleEnvio.fecha_salida) }}</p>
                  <p><strong>Fecha de Entrega:</strong> {{ formatFecha(detalleEnvio.fecha_entrada_maxima) }}</p>
                  <p><strong>Horario de Salida:</strong> {{ formatHora(detalleEnvio.horario_salida) }}</p>
                  <p><strong>Horario de Entrega:</strong> {{ formatHora(detalleEnvio.horario_entrega) }}</p>
                  <p><strong>Guía de Transportista:</strong> {{ detalleEnvio.guias_transportistas_concatenadas || '-' }}</p>
                  <p><strong>Lead Time Esperado:</strong> {{ detalleEnvio.lead_time_esperado }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="showModalArchivos" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uploadModalLabel">Documentos</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" @click="showModalArchivos = false"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Formulario para subir archivos -->
            <!-- Tabla con los documentos agregados -->
            <div class="mt-4">
              <table class="table table-font-small">
                <thead class="table-light padding-custom">
                  <tr>
                    <th>Tipo de Documento</th>
                    <th>Estado</th>
                    <th>Archivo</th>
                    <th>Comentario</th>
                    <th class="col-acciones">Acciones</th>
                  </tr>
                </thead>
                <tbody class="table-border-bottom-0 padding-custom">
                  <tr v-for="(archivo, index) in archivos" :key="index">
                    <td>{{ archivo.tipo }}</td>
                    <td class="p-1">
                      <span :class="getBadgeClass(archivo.id_estados_envio)">
                        {{ archivo.estado }}
                      </span>
                    </td>
                    <td>
                      <span v-if="esImagen(archivo.nombre)">
                        <img :src="archivo.url" class="img-thumbnail" width="50" />
                      </span>
                      {{ archivo.nombre }}
                    </td>
                    <td>{{ archivo.comentario }}</td>
                    <td class="col-acciones">
                      <button class="btn-icon btn-icon-view" @click="verArchivo(archivo)" title="Ver archivo" aria-label="Ver archivo"><i class="bi bi-eye"></i></button>
                      <button v-if="esSuperAdmin()" class="btn-icon btn-icon-del" @click="eliminarArchivo(archivo.id)" title="Eliminar archivo" aria-label="Eliminar archivo"><i class="bi bi-trash"></i></button>
                    </td>
                  </tr>
                  <tr v-if="archivos.length === 0" class="empty-row"><td colspan="4">No hay archivos subidos</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modalEstados" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uploadModalLabel">Gestión de Estados</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" @click="modalEstados = false"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label for="">Estado del Envío</label>
                <select name="" id="" class="form-control" v-model="nuevoEstado">
                  <option v-for="item in estadosEnvio" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                </select>
              </div>

            </div>
            <div class="row mt-2" v-if="nuevoEstado != 19 && nuevoEstado != 12">
              <div class="col-md-12">
                <label class="form-label">Tipo de Documento</label>
                <select v-model="nuevoArchivo.tipo" class="form-control">
                  <option disabled value="">Seleccione un tipo</option>
                  <option>GUIA DE REMISIÓN (PUNTO DE ORIGEN)</option>
                  <option>FOTOS DE DOCUMENTOS (PUNTO DE ORIGEN)</option>
                  <option>CARGO GUIA DE REMISIÓN (PUNTO DE ENTREGA)</option>
                  <option>FOTOS DE DOCUMENTOS (PUNTO DE ENTREGA)</option>
                </select>
              </div>
              <div class="col-md-12">
                <label class="form-label">Comentario</label>
                <textarea v-model="nuevoArchivo.comentario" class="form-control" rows="2"></textarea>
              </div>
            </div>

            <div class="form-group mt-2" v-if="nuevoEstado == 19">
              <label for="tipoArchivo">Conformidad de Draeger (N°hojas)</label>
              <select v-model="conformidad_draeger" class="form-control" id="tipoArchivo">
                <option value="SIN RECEPCIONAR">SIN RECEPCIONAR</option>
                <option value="RECEPCIONADO">RECEPCIONADO</option>
                <option value="OBSERVADO">OBSERVADO</option>
              </select>
            </div>

            <!-- Drag & Drop Zone -->
            <div v-if="nuevoEstado != 19 && nuevoEstado != 12" class="dropzone mt-3" @dragover.prevent="dragging = true" @dragleave.prevent="dragging = false"
              @drop.prevent="soltarArchivo" @click="abrirExplorador">
              <div v-if="!nuevoArchivo.nombre" class="dropzone-content">
                <i class="fas fa-cloud-upload-alt fa-3x"></i>
                <p>Arrastra un archivo aquí o haz clic para seleccionar</p>
                <input type="file" class="d-none" ref="fileInput" @change="seleccionarArchivo" />
              </div>
              <div v-else class="dropzone-preview">
                <img v-if="esImagen(nuevoArchivo.nombre)" :src="nuevoArchivo.url" class="img-thumbnail" width="100" />
                <p>{{ nuevoArchivo.nombre }}</p>
              </div>
            </div>
            <div v-if="nuevoEstado == 12">
              <p class="p-3 text-danger">AHORA SUBE TU CARGO ESCANEADO POR GESTIÓN DE CARGOS</p>
            </div>
            <br>
            <button @click="gestionEstado()" class="btn btn-primary btn-sm float-end">Actualizar Estado</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Gestión de Guías -->
    <div v-if="showModalGestionGuias" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
      <!-- scrollable para envíos con muchos documentos -->
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-file-earmark-text me-2"></i>Gestión de Guías</h5>
            <button type="button" class="btn-close" @click="showModalGestionGuias = false"></button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
              <span class="text-muted small">Envío</span>
              <span class="badge bg-primary fs-6 fw-semibold">{{ envioSeleccionadoGuias?.rastreo }}</span>
              <span v-if="envioSeleccionadoGuias?.documentos?.length" class="badge bg-light text-dark border">
                {{ envioSeleccionadoGuias.documentos.length }} {{ envioSeleccionadoGuias.documentos.length === 1 ? 'documento' : 'documentos' }}
              </span>
            </div>
            <div v-if="envioSeleccionadoGuias && envioSeleccionadoGuias.documentos && envioSeleccionadoGuias.documentos.length">

              <!-- Tabla desktop -->
              <div class="d-none d-md-block table-responsive">
                <table class="table table-bordered table-sm table-hover align-middle">
                  <thead class="table-primary text-center" style="font-size:0.82rem;">
                    <tr>
                      <th>Orden Compra</th>
                      <th>Factura</th>
                      <th>OTM</th>
                      <th>Docs. Extras</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody style="font-size:0.85rem;">
                    <tr v-for="detalle in envioSeleccionadoGuias.documentos" :key="detalle.id">
                      <td>{{ detalle.orden_compra || '-' }}</td>
                      <td>{{ detalle.numero_factura || '-' }}</td>
                      <td>{{ detalle.otm || '-' }}</td>
                      <td>{{ detalle.documentos_extras || '-' }}</td>                      
                      <td class="text-center" style="white-space:nowrap; width:90px;">
                        <button v-if="detalle.archivo_url" class="btn btn-sm btn-info me-1" @click="verArchivoGuia(detalle.archivo_url)" title="Ver archivo">
                          <i class="bi bi-eye"></i>
                        </button>
                        <button v-if="esSuperAdminOInterno()" class="btn btn-sm btn-primary" @click="subirArchivoGuia(detalle)" title="Subir archivo">
                          <i class="bi bi-upload"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Cards móvil -->
              <div class="d-block d-md-none">
                <div v-for="(detalle, i) in envioSeleccionadoGuias.documentos" :key="detalle.id"
                  class="card mb-3 border" style="border-color:#c5cae9!important; border-radius:10px; overflow:hidden;">
                  <div class="card-header py-2 d-flex justify-content-between align-items-center"
                    style="background:#3f51b5!important; color:#fff!important; border-bottom:none;">
                    <span class="fw-semibold small">Documento #{{ i + 1 }}</span>
                    <span v-if="detalle.numero_factura"
                      class="badge fw-normal px-2 py-1"
                      style="background:rgba(255,255,255,0.25)!important; color:#fff!important; font-size:0.78rem;">
                      {{ detalle.numero_factura }}
                    </span>
                  </div>
                  <div class="card-body py-3 px-3" style="background:#f8f9ff;">
                    <div class="row g-2" style="font-size:0.85rem;">
                      <div class="col-6">
                        <div class="text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.4px;">Orden Compra</div>
                        <div class="fw-semibold text-dark">{{ detalle.orden_compra || '—' }}</div>
                      </div>
                      <div class="col-6">
                        <div class="text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.4px;">Factura</div>
                        <div class="fw-semibold text-dark">{{ detalle.numero_factura || '—' }}</div>
                      </div>
                      <div class="col-12" v-if="detalle.documentos_extras">
                        <div class="text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.4px;">Docs. Extras</div>
                        <div class="fw-semibold text-dark">{{ detalle.documentos_extras }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-2 d-flex gap-2" style="background:#eef0fb!important; border-top:1px solid #c5cae9!important; color:inherit!important; font-weight:normal!important; padding:8px 12px!important;">
                    <button v-if="detalle.archivo_url" class="btn btn-sm flex-fill"
                      style="background:#0097a7; color:#fff; border:none;"
                      @click="verArchivoGuia(detalle.archivo_url)">
                      <i class="bi bi-eye me-1"></i>Ver archivo
                    </button>
                    <button v-if="esSuperAdminOInterno()" class="btn btn-sm flex-fill"
                      style="background:#3f51b5; color:#fff; border:none;"
                      @click="subirArchivoGuia(detalle)">
                      <i class="bi bi-upload me-1"></i>Subir archivo
                    </button>
                  </div>
                </div>
              </div>

            </div>
            <div v-else class="text-muted text-center py-3">No hay detalles de guías para este envío.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para Subir Archivos de Guía -->
    <div v-if="showModalArchivoGuia" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-cloud-arrow-up me-2"></i>Subir archivo del documento</h5>
            <button type="button" class="btn-close" @click="cerrarModalArchivoGuia"></button>
          </div>
          <div class="modal-body">
            <!-- Datos del documento: solo los que tiene -->
            <div v-if="detalleGuiaSeleccionado && referenciasGuia(detalleGuiaSeleccionado).length" class="guia-refs">
              <div v-for="ref in referenciasGuia(detalleGuiaSeleccionado)" :key="ref.label" class="guia-ref">
                <span class="guia-ref-label">{{ ref.label }}</span>
                <span class="guia-ref-valor">{{ ref.valor }}</span>
              </div>
            </div>
            <!-- El tipo de archivo es fijo: se muestra como dato, no como select bloqueado -->
            <div class="guia-tipo">
              <i class="bi bi-file-earmark-pdf"></i>
              <div>
                <div class="guia-tipo-nombre">{{ archivoGuia.tipo }}</div>
                <div class="guia-tipo-detalle">PDF (escaneo o foto en PDF)</div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-12">
                <label class="form-label">Comentario <span class="guia-opcional">(opcional)</span></label>
                <textarea v-model="archivoGuia.comentario" class="form-control" rows="2"
                  placeholder="Algún detalle sobre el archivo"></textarea>
              </div>
            </div>

            <div class="dropzone mt-3" :class="{ 'drop-hover': draggingGuia }" @dragover.prevent="draggingGuia = true"
              @dragleave.prevent="draggingGuia = false" @drop.prevent="soltarArchivoGuia" @click="abrirExploradorGuia">
              <div v-if="!archivoGuia.nombre" class="dropzone-content">
                <i class="fas fa-cloud-upload-alt fa-3x"></i>
                <p>Arrastra un archivo aquí o haz clic para seleccionar</p>
                <input type="file" class="d-none" ref="fileInputGuia" @change="seleccionarArchivoGuia" />
              </div>
              <div v-else class="dropzone-preview">
                <img v-if="esImagen(archivoGuia.nombre)" :src="archivoGuia.url" class="img-thumbnail" width="100" />
                <p><strong>{{ archivoGuia.nombre }}</strong></p>
                <button class="btn btn-sm btn-outline-secondary mt-2" @click.stop="limpiarArchivoGuia">
                  <i class="bi bi-x-circle"></i> Cambiar archivo
                </button>
              </div>
            </div>

            <p v-if="!archivoGuia.archivo" class="guia-hint">Selecciona el archivo para poder subirlo.</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarModalArchivoGuia" :disabled="loadingSubirArchivoGuia">Cancelar</button>
            <button class="btn btn-primary" @click="guardarArchivoGuia" :disabled="!archivoGuia.archivo || loadingSubirArchivoGuia">
              <i class="bi bi-upload me-1"></i> Subir archivo
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ShippingANW from '@/components/ShippingANWDocument.vue'
import PaginacionListado from '@/components/PaginacionListado.vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import { validarRangoFechas, LIMITE_REPORTE_RUTA, mensajeErrorDescarga } from '@/utils/rangoFechas'

export default {
  name: 'ShippingListPage',
  components: { ShippingANW, PaginacionListado },
  data() {
    return {
      isLoading: true,
      tipoEnvio: this.$route.params.tipo_envio,
      nuevoEstado: 0,
      conformidad_draeger: 'SIN RECEPCIONAR',
      modalDetalle: false,
      showModalArchivos: false,
      modalGestionANW: false,
      modalEstados: false,
      envioId: null,
      estadosEnvio: [],
      codigosMetodoEnvio: [],
      filtros: {
        tipo_paquete: "documentos",
        ruc: '',
        razon_social: '',
        cliente_final: '',
        pedido: '',
        guia: '',
        serie_guia: '',
        numero_factura: '',
        otm: '',
        fecha_inicio: '',
        fecha_fin: '',
        id_modalidades_envio: '',
        cod_metodo_envio_id: '',
        id_estados_envio: ''
      },
      comentario: '',
      detalleEnvio: {},
      envios: [],
      pagina: 1,
      porPagina: 25,
      totalPaginas: 1,
      totalEnvios: 0,
      empresas: [
        { id: 1, nombre: 'Empresa A' },
        { id: 2, nombre: 'Empresa B' },
      ],
      tipoUnidades: [
        { id: 3, tipo_unidad: 'Camión 10T' },
        { id: 4, tipo_unidad: 'Camión 20T' },
      ],
      archivos: [],
      nuevoArchivo: {
        tipo: '',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      },
      dragging: false,
      envioSeleccionadoGuias: null,
      showModalGestionGuias: false,
      showModalArchivoGuia: false,
      detalleGuiaSeleccionado: null,
      tipoArchivoGuia: 'pdf',
      archivoGuia: {
        tipo: 'Cargo firmado por el cliente (en destino)',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      },
      draggingGuia: false,
      loadingSubirArchivoGuia: false,
    }
  },
  watch: {
    '$route.path'() {
      this.limpiarFiltros()
      this.tipoEnvio = this.$route.params.tipo_envio
      if (this.tipoEnvio == 'exclusivos') {
        this.filtros.id_modalidades_envio = 3
      } else if (this.tipoEnvio == 'consolidados') {
        this.filtros.id_modalidades_envio = 2
      } else if (this.tipoEnvio == 'aereos') {
        this.filtros.id_modalidades_envio = 4
      }
      this.buscarEnvios()
    },
  },
  computed: {
    direccionRemitente() {
      return this.armarDireccion(this.detalleEnvio?.sucursal_remitente, this.detalleEnvio?.ubicacion_remitente)
    },
    direccionDestinatario() {
      return this.armarDireccion(this.detalleEnvio?.sucursal_destinatario, this.detalleEnvio?.ubicacion_destinatario)
    },
    rutaEnvio() {
      switch (this.tipoEnvio) {
        case 'exclusivos':
          return '/envios-documentos/exclusivo'
        case 'consolidados':
          return '/envios-documentos/consolidado'
        case 'aereos':
          return '/envios-documentos/aereo'
        default:
          return '/envios-documentos/desconocido'
      }
    },
  },
  mounted() {
    if (this.tipoEnvio == 'exclusivos') {
      this.filtros.id_modalidades_envio = 3
    } else if (this.tipoEnvio == 'consolidados') {
      this.filtros.id_modalidades_envio = 2
    } else if (this.tipoEnvio == 'aereos') {
      this.filtros.id_modalidades_envio = 4
    }
    this.getEstadosEnvio()
    this.getCodigoMetodoEnvio()
    this.buscarEnvios()
    this.user = JSON.parse(localStorage.getItem('user'))
  },
  methods: {
    // El backend mezcla formatos: horario_salida viene "15:00:00" y
    // horario_entrega viene "3:00 PM". Se normalizan a 12h.
    formatHora(hora) {
      if (!hora) return '-'

      const texto = String(hora).trim()
      if (!/^\d{1,2}:\d{2}(:\d{2})?$/.test(texto)) return texto

      const [h, m] = texto.split(':').map(Number)
      if (isNaN(h) || isNaN(m)) return texto

      const fecha = new Date(1970, 0, 1, h, m)
      return fecha.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit', hour12: true })
    },
    // La direccion completa solo esta disponible si viene el objeto de sucursal.
    // Si no, se cae a la ubicacion (distrito - provincia) que siempre viene.
    armarDireccion(sucursal, ubicacionFallback) {
      const partes = [
        sucursal?.direccion,
        sucursal?.distrito_nombre,
        sucursal?.provincia_nombre
      ].filter(Boolean)

      if (partes.length) return partes.join(' - ')
      return ubicacionFallback || '-'
    },
    esAdmin() {
      const cargo = this.user?.cargo?.toLowerCase()
      return cargo === 'admin' || cargo === 'admin-draeger'
    },

    esSuperAdmin() {
      return this.user?.cargo?.toLowerCase() === 'admin'
    },
    esSuperAdminOInterno() {
      return this.user?.cargo?.toLowerCase() === 'admin' || this.user?.tipo_usuario == 'interno'
    },
    async getCodigoMetodoEnvio() {
      try {
        const response = await axios.get('cod-metodo-envio')
        this.codigosMetodoEnvio = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargando códigos de método de envío:', error)
      }
    },
    getTipoEnvioTexto() {
      switch (this.tipoEnvio) {
        case 'exclusivos':
          return 'Exclusivos'
        case 'consolidados':
          return 'Consolidados'
        case 'aereos':
          return 'Aéreos'
        default:
          return 'Desconocido'
      }
    },
    async getEstadosEnvio() {
      this.isLoading = true;
      const { data } = await axios.get('estados-envio')
      this.estadosEnvio = data      
      this.isLoading = false;
    },
    formatFecha(fecha) {
      if (!fecha) return ''
      const [year, month, day] = fecha.split('-')
      return new Date(year, month - 1, day).toLocaleDateString('es-PE', {
        dateStyle: 'short',
      })
    },
    editarEnvio(envio) {
      this.$router.push(`/editar-envio-documento/${envio.id_envio}`)
    },
    abrirGestionarModal(item) {
      this.detalleEnvio = item;
      this.modalGestionANW = true
    },
    mostrarDetalle(item) {
      this.modalDetalle = true
      this.detalleEnvio = { ...item }
    },
    cerrarDetalle() {
      this.modalDetalle = false
    },
    obtenerNombreEmpresa(id) {
      return this.empresas.find((e) => e.id === id)?.nombre || 'No especificado'
    },
    obtenerTipoUnidad(id) {
      return (
        this.tipoUnidades.find((t) => t.id === id)?.tipo_unidad ||
        'No especificado'
      )
    },
    async guardarGestion() {
      try {
        const resultado = await this.$refs.shippingANWRef.submitDesdePadre();
        console.log('Resultado desde el hijo:', resultado);
      } catch (error) {
        console.error('Error al guardar desde el hijo:', error);
      }
    },
    async buscarEnvios() {
      this.isLoading = true;
      this.filtros.tipo_paquete = "documentos";
      if (this.tipoEnvio == 'exclusivos') {
        this.filtros.id_modalidades_envio = 3
      } else if (this.tipoEnvio == 'consolidados') {
        this.filtros.id_modalidades_envio = 2
      } else if (this.tipoEnvio == 'aereos') {
        this.filtros.id_modalidades_envio = 4
      }
      try {
        const { data } = await axios.get('envios', { params: { ...this.filtros, page: this.pagina } })
        // Si la página quedó fuera de rango (p. ej. al eliminar el último envío de la última página), ir a la última
        if (data.data.length === 0 && data.total > 0 && this.pagina > data.last_page) {
          this.pagina = data.last_page
          return this.buscarEnvios()
        }
        this.envios = data.data
        this.totalPaginas = data.last_page
        this.totalEnvios = data.total
      } catch (error) {
        console.error('Error al buscar envíos', error)
      } finally {
        this.isLoading = false;
      }
    },
    aplicarFiltros() {
      this.pagina = 1
      this.buscarEnvios()
    },
    cambiarPagina(n) {
      this.pagina = n
      this.buscarEnvios()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async eliminarEnvio(envio) {
      const confirmacion = await Swal.fire({
        title: '¿Estás seguro?',
        text: `Vas a eliminar el envío ${envio.rastreo || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
      });

      if (confirmacion.isConfirmed) {
        try {
          await axios.delete(`/envios/${envio.id_envio}`);

          await Swal.fire({
            icon: 'success',
            title: 'Eliminado',
            text: 'El envío fue eliminado correctamente.',
            timer: 1500,
            showConfirmButton: false,
          });

          this.buscarEnvios();

        } catch (error) {
          console.error(error);
          
          let errorMessage = 'Hubo un problema al eliminar el envío.';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
          });
        }
      }
    },
    async aceptarEnvio() {
      await this.actualizarEnvio('aceptar')
    },

    async rechazarEnvio() {
      await this.actualizarEnvio('rechazar')
    },
    async actualizarEnvio(accion) {
      try {
        await axios.get(`${accion}-envio/${this.detalleEnvio.id_envio}`)
        this.cerrarDetalle()
        this.buscarEnvios()
        Swal.fire({
          icon: 'success',
          title: 'Envío Actualizado',
          text: 'Los datos se han actualizado correctamente.',
        })
      } catch (error) {
        console.error(`Error al ${accion} envío`, error)
      }
    },

    async exportarExcel() {
      try {
        const response = await axios.get('/exportar-envios-documentos', {
          params: this.filtros,
          responseType: 'blob'
        });

        // Generar nombre dinámico: provincia_mercaderia_YYYYmmddHHMMss.xlsx
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const fileName = `provincia_documentos_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.xlsx`;

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error al exportar:', error);
      }
    },

    async exportarReportePdf() {
      const errorRango = validarRangoFechas(this.filtros.fecha_inicio, this.filtros.fecha_fin, LIMITE_REPORTE_RUTA);
      if (errorRango) {
        Swal.fire({ icon: 'info', title: 'Ajusta el rango de fechas', text: errorRango });
        return;
      }
      try {
        const response = await axios.get('/envios-documentos-reporte', {
          params: this.filtros,
          responseType: 'blob'
        });

        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const fileName = `r_ruta_doc_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.pdf`;

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error al exportar reporte PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'No se pudo generar el reporte',
          text: await mensajeErrorDescarga(error, 'Ocurrió un error al generar el archivo. Intenta nuevamente.'),
        });
      }
    },

    getBadgeClass(estado) {
      const badgeMap = {
        1: 'bg-secondary', // Solicitud Recibida
        2: 'bg-success',   // Aprobada
        3: 'bg-danger',    // Rechazada
        4: 'bg-warning',   // En espera
        5: 'bg-info',      // Recojo en curso
        6: 'bg-success',   // Recojo confirmado
        7: 'bg-warning',   // Embarque/Despacho
        8: 'bg-info',      // Traslado en curso
        9: 'bg-primary',   // Llegada a destino
        10: 'bg-info',     // Entrega en curso
        11: 'bg-success',  // Entregado
        12: 'bg-primary',  // Cargo PDF
        13: 'bg-success',  // Cargo Físico Confirmado
        14: 'bg-danger',   // Servicio Observado
        15: 'bg-warning',  // Reprogramado
        16: 'bg-danger'    // Cancelado
      };

      return `badge ${badgeMap[estado] || 'bg-secondary'} breakable-badge`;
    },
    limpiarFiltros() {
      Object.keys(this.filtros).forEach(
        (key) =>
          (this.filtros[key] = key === 'id_modalidades_envio' ? '' : ''),
      )
      this.pagina = 1
      this.buscarEnvios()
    },

    abrirCargarArchivosModal(envio) {
      this.envioId = envio.id_envio
      this.cargarArchivos(envio.id_envio)
      this.showModalArchivos = true
    },
    seleccionarArchivo(event) {
      this.procesarArchivo(event.target.files[0])
    },
    abrirExplorador() {
      this.$refs.fileInput.click()
    },
    soltarArchivo(event) {
      this.dragging = false
      this.procesarArchivo(event.dataTransfer.files[0])
    },
    procesarArchivo(file) {
      if (file) {
        this.nuevoArchivo = {
          ...this.nuevoArchivo,
          archivo: file,
          nombre: file.name,
          url: URL.createObjectURL(file),
        }
      }
    },
    openEstadoEnvio(item) {
      this.detalleEnvio = { ...item }
      this.nuevoEstado = this.detalleEnvio.id_estados_envio
      this.modalEstados = true
    },
    async gestionEstado() {
      let data = {
        id_envio: this.detalleEnvio.id_envio,
        id_estados_envio: this.nuevoEstado
      }
      if (this.nuevoEstado == 19) {
        data.conformidad_draeger = this.conformidad_draeger
      }
      try {
        await axios.post(`estado-envio`, data)
        await this.agregarArchivo();
        this.buscarEnvios()
        this.cargarArchivos(this.detalleEnvio.id_envio)
        Swal.fire({
          icon: 'success',
          title: 'Estado Actualizado',
          text: 'El estado se ha actualizado correctamente.',
        })
        
        // Limpiar el formulario del modal
        this.limpiarFormularioModal()
        this.modalEstados = false
      } catch (error) {
        console.error(`Error al actualizar el estado del envío`, error)
      }
    },
    limpiarFormularioModal() {
      // Reiniciar los campos del formulario
      this.nuevoEstado = 0;
      this.conformidad_draeger = 'SIN RECEPCIONAR';
      this.nuevoArchivo = {
        tipo: '',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      };
      
      // Limpiar el input file si existe
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    async agregarArchivo() {
      const formData = new FormData()
      formData.append('envio_id', this.detalleEnvio.id_envio)
      formData.append('tipo', this.nuevoArchivo.tipo)
      formData.append('archivo', this.nuevoArchivo.archivo)
      formData.append('comentario', this.nuevoArchivo.comentario)
      formData.append('id_estados_envio', this.nuevoEstado)

      try {
        const { data } = await axios.post('/subir-archivo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        this.archivos.push(data)
        this.nuevoArchivo = {
          tipo: '',
          archivo: null,
          nombre: '',
          comentario: '',
        }

      } catch (error) {
        console.error('Error al subir archivo', error)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo subir el archivo. Inténtelo de nuevo.',
        })
      }
    },
    async cargarArchivos(envioId) {
      try {
        const { data } = await axios.get(`/archivos/${envioId}`)
        this.archivos = data
      } catch (error) {
        console.error('Error al obtener archivos', error)
      }
    },

    verArchivo(archivo) {
      window.open(archivo.url, '_blank')
    },
    verArchivoGuia(url) {
      if (!url) {
        Swal.fire({
          icon: 'warning',
          title: 'Archivo no disponible',
          text: 'No se encontró la URL del archivo de guía.',
        })
        return
      }

      window.open(url, '_blank')
    },
    async eliminarArchivo(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      })

      if (result.isConfirmed) {
        try {
          await axios.delete(`/eliminar-archivo/${id}`)
          this.cargarArchivos(this.envioId)

          Swal.fire({
            icon: 'success',
            title: 'Eliminado',
            text: 'El archivo ha sido eliminado correctamente.',
            confirmButtonText: 'OK',
          })
        } catch (error) {
          console.error('Error al eliminar archivo', error)

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo eliminar el archivo.',
            confirmButtonText: 'OK',
          })
        }
      }
    },

    esImagen(nombre) {
      return /\.(jpg|jpeg|png|gif)$/i.test(nombre)
    },
    abrirGestionGuiasModal(envio) {
      this.envioSeleccionadoGuias = envio;
      this.showModalGestionGuias = true;
    },
    // Datos del documento para el modal de subida (solo los que tienen valor)
    referenciasGuia(detalle) {
      return [
        { label: 'Orden de compra', valor: detalle.orden_compra },
        { label: 'Factura', valor: detalle.numero_factura },
        { label: 'OTM', valor: detalle.otm },
      ].filter(ref => ref.valor)
    },
    subirArchivoGuia(detalle) {
      Swal.fire({
        title: '¿Subir archivo de guía?',
        text: 'Solo puedes subir si ya actualizaste el estado a CARGO PDF SUBIDO.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.detalleGuiaSeleccionado = detalle;
          this.limpiarArchivoGuia();
          this.showModalArchivoGuia = true;
        }
      });
    },
    cerrarModalArchivoGuia() {
      this.showModalArchivoGuia = false;
      this.detalleGuiaSeleccionado = null;
      this.limpiarArchivoGuia();
    },
    limpiarArchivoGuia() {
      this.archivoGuia = {
        tipo: 'Cargo firmado por el cliente (en destino)',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      };
      this.tipoArchivoGuia = 'pdf';
      this.draggingGuia = false;
    },
    seleccionarArchivoGuia(event) {
      this.procesarArchivoGuia(event.target.files[0]);
    },
    abrirExploradorGuia() {
      this.$refs.fileInputGuia.click();
    },
    soltarArchivoGuia(event) {
      this.draggingGuia = false;
      this.procesarArchivoGuia(event.dataTransfer.files[0]);
    },
    procesarArchivoGuia(file) {
      if (file) {
        this.archivoGuia = {
          ...this.archivoGuia,
          archivo: file,
          nombre: file.name,
          url: URL.createObjectURL(file),
        };
      }
    },
    async guardarArchivoGuia() {
      this.loadingSubirArchivoGuia = true;
      if (!this.archivoGuia.archivo) {
        Swal.fire({
          icon: 'warning',
          title: 'Campo requerido',
          text: 'Debes seleccionar un archivo.',
        });
        this.loadingSubirArchivoGuia = false;
        return;
      }

      const formData = new FormData();
      formData.append('envio_id', this.envioSeleccionadoGuias.id_envio);
      formData.append('tipo', this.archivoGuia.tipo);
      formData.append('archivo', this.archivoGuia.archivo);
      formData.append('comentario', this.archivoGuia.comentario);
      formData.append('id_estados_envio', 12);
      formData.append('id_envio_detalle', this.detalleGuiaSeleccionado.id);

      try {
        await axios.post('/subir-archivo', formData);
        await this.buscarEnvios();

        const envioActualizado = this.envios.find(
          (envio) => envio.id_envio === this.envioSeleccionadoGuias.id_envio,
        );
        if (envioActualizado) {
          this.envioSeleccionadoGuias = envioActualizado;
        }

        Swal.fire({
          icon: 'success',
          title: 'Archivo subido',
          text: 'El archivo se ha subido correctamente.',
        });

        this.cerrarModalArchivoGuia();
      } catch (error) {
        let mensaje = '';

        if (error.response) {
          mensaje = JSON.stringify(error.response.data);
        } else if (error.request) {
          mensaje = 'No hubo respuesta del servidor';
        } else {
          mensaje = error.message;
        }

        Swal.fire({
          icon: 'error',
          title: 'Error real',
          html: `<pre style="text-align:left">${mensaje}</pre>`,
          width: 600,
        });
      } finally {
        this.loadingSubirArchivoGuia = false;
      }
    },
  },
}
</script>

<style scoped>
.modal.fade.show {
  display: block;
}

.modal.show {
  background: rgba(0, 0, 0, 0.5);
}


.badge {
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 5px;
  line-height: 1.2;
}

.breakable-badge {
  white-space: normal;
  word-break: break-word;
}

.table-font-small {
  font-size: 0.75rem;
}



.table th,
.table td {
  white-space: normal;
  /* Permite saltos de línea */
  /* Oculta el exceso de contenido */
  text-overflow: ellipsis;
  /* Mantiene los puntos suspensivos si el contenido es demasiado grande */
  word-wrap: break-word;
  /* Rompe palabras largas si es necesario */
  overflow-wrap: break-word;
  /* Alternativa moderna */
  text-align: center;
  vertical-align: middle;
}



@media (max-width:768px) {

  .fecha-mobile {
    min-width: 75px;
  }

  .cliente-mobile {
    min-width: 145px;
  }

}

@media (min-width: 768px) {
  .table-responsive {
    overflow: visible !important;
  }

  /* Anchos de columna: los reparte el navegador según el contenido (ver estándar en admin-tables.css) */
  .table-doc-list {
    width: 100%;
  }
}

.table-gestion-guias {
  table-layout: fixed;
  width: 100%;
}

.table-gestion-guias th,
.table-gestion-guias td {
  font-size: 0.75rem;
  vertical-align: middle;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  padding: 0.45rem;
}

.table-gestion-guias th:nth-child(1),
.table-gestion-guias td:nth-child(1) {
  width: 13%;
}

.table-gestion-guias th:nth-child(2),
.table-gestion-guias td:nth-child(2) {
  width: 13%;
}

.table-gestion-guias th:nth-child(3),
.table-gestion-guias td:nth-child(3) {
  width: 10%;
}

.table-gestion-guias th:nth-child(4),
.table-gestion-guias td:nth-child(4) {
  width: 12%;
}

.table-gestion-guias th:nth-child(5),
.table-gestion-guias td:nth-child(5) {
  width: 10%;
}

.table-gestion-guias th:nth-child(6),
.table-gestion-guias td:nth-child(6) {
  width: 12%;
}

.table-gestion-guias th:nth-child(7),
.table-gestion-guias td:nth-child(7) {
  width: 14%;
}

.table-gestion-guias th:nth-child(8),
.table-gestion-guias td:nth-child(8) {
  width: 16%;
  text-align: center;
}

.table-gestion-guias td:nth-child(8) .btn {
  width: 100%;
  white-space: normal;
  line-height: 1.1;
  padding: 0.35rem 0.4rem;
}

.table-gestion-guias-wrapper {
  overflow-x: hidden;
}

.dropdown-menu {
  min-width: 180px;
}

.dropdown-item i {
  margin-right: 8px;
}

.custom-dropdown {
  position: absolute !important;
  /* Permite que se desplace sobre otras filas */
  z-index: 1050 !important;
  /* Asegura que esté sobre otros elementos */
  left: auto !important;
  /* Evita que se recorte en la tabla */
  right: 0 !important;
  /* Alinea correctamente */
}



.dropdown-menu.show {
  position: absolute !important;
  z-index: 1050 !important;
  will-change: transform;
}

.dropzone {
  border: 2px dashed #007bff;
  padding: 20px;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
}

.dropzone:hover,
.dropzone.drop-hover {
  background: rgba(0, 123, 255, 0.1);
}

.dropzone-content i {
  color: #007bff;
}

.dropzone-preview img {
  max-width: 100px;
  margin-top: 10px;
}

.swal2-container {
  z-index: 9999 !important;
}

.modal {
  z-index: 90;
}

.table-responsive {
  min-height: 250px;
}

/* Detalle */
</style>
